import MatchedMap from 'utilities/src/matchedMap';

import { BlogSizeEnum } from './_size';

/**
 * Button Common Classes
 */

const buttonBlogClasses =
  'text-[1.05rem] leading-6 font-medium disabled:opacity-40 transition-colors duration-300';
const buttonBlogTextClasses = 'extra-button';

/**
 * Button Common Size Classes
 */

const buttonBlogSizeClassesMap = new MatchedMap([
  [BlogSizeEnum.Large, 'py-3 px-4'],
  [BlogSizeEnum.Medium, 'py-2 px-3'],
  [BlogSizeEnum.Small, 'py-1 px-2'],
]);

const buttonBlogOnlyIconSizeClassesMap = new MatchedMap([
  [BlogSizeEnum.Large, 'p-3'],
  [BlogSizeEnum.Medium, 'p-2'],
  [BlogSizeEnum.Small, 'p-1'],
]);

export default {
  buttonBlogClasses,
  buttonBlogTextClasses,
  buttonBlogSizeClassesMap,
  buttonBlogOnlyIconSizeClassesMap,
};
